import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTheme } from '@mui/material/styles';
import { Languages } from '@beable/content-types';
import { getStyles } from './styles';

interface LanguageToggleProps {
  onToggle: (language: string) => void;
  selectedLanguage: string;
  tooltipMessage?: string;
  className?: string;
  showBorders?: boolean;
}

export default function LanguageToggle({
  onToggle,
  selectedLanguage,
  className = '',
  showBorders = false,
}: LanguageToggleProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <ToggleButtonGroup
      value={selectedLanguage}
      exclusive
      onChange={(_, value) => { onToggle(value); }}
      className={className}
      sx={[
        { marginLeft: 10 },
        ...(!showBorders ? [styles.groupedNoBorders] : []),
      ]}
    >
      {Object.values(Languages).map((lang, index) => (
        <ToggleButton
          value={lang}
          sx={styles.buttons}
          key={index}
          data-cy={`${lang}-toggle-button`}
        >
            {lang}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
